import styled from 'styled-components';

const Centered = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export { Centered }